export default {
  path:'/campaign-settings',
  preload:false,
  middlewares: [
    {
      "rms_ui/validatePermissionsMiddleware" : [ 
        ["rms.campaign_admin", "rms.owner_user_admin"],
        "/"
      ]
    }
  ]
}
